import { Routes } from '@/api/Routes';
import { http } from '@/common/utils/HttpServices';
import { FormulaireCompteurDto } from '@/models/FormulaireCompteurDto';

class CompteurService {

    public async sendCounterForm(formulaireCompteurDto: FormulaireCompteurDto, factures: File[]): Promise<any> {
        const formData = new FormData();

        const transformToBlobJson = (data: any) => new Blob([JSON.stringify(data)], { type: 'application/json' });

        formData.set('formulaireCompteurDTO', transformToBlobJson(formulaireCompteurDto));

        const fileToBlob = async (file: File): Promise<Blob> => {
            return new Promise(resolve => {
                const reader = new FileReader();
                reader.onloadend = () => reader.readAsBinaryString(file);
                resolve(file);
            });
        };

        if (factures !== undefined)
        await Promise.all(
            factures.map(async (file: File) => {
                if (file !== undefined) {
                    const blob = await fileToBlob(file);
                    formData.append('factures', blob, file.name);
                }
            })
        );

        return http.post(Routes.CompteurRoutes.SendCounterForm(), formData);
    }

}

export default new CompteurService();
